<div class="col-12 col-md-8 offset-md-2">
  <div class="card m-t">
    <div class="row">
      <div class="col-12 pt-4">
        <p class="heading">You have successfully unsubscribed from our mailing list.</p>
      </div>
    </div>
  </div>
</div>
